import { SET_IS_OPEN_MODAL } from '../actionTypes';
import { createTemplateModalActions } from '../reducer';

export default (value) => createTemplateModalActions[SET_IS_OPEN_MODAL](value);
